import { Component, OnInit, inject } from '@angular/core';
import { AuthorizationService } from 'src/app/Services/authorization/authorization.service';
import { AppGlobals } from 'src/app/Shared/app.globals';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-relogin-dialog',
  templateUrl: './relogin-dialog.component.html',
  styleUrls: ['./relogin-dialog.component.css'],
  providers: [AppGlobals],
})
export class ReloginDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ReloginDialogComponent>>(MatDialogRef);
  private auth = inject(AuthorizationService);
  private router = inject(Router);
  private dRef = inject(MatDialog);

  constructor() {
    const dialogRef = this.dialogRef;

    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.auth.reLoginDialogLoaded = true;
  }
  logInAgain() {
    localStorage.clear();
    this.auth.reLoginDialogLoaded = false;
    this.dRef.closeAll();
    const pathname = location.pathname;
    const homePaths = ['/home', '/home/', '/'];
    if (!homePaths.includes(pathname)) {
      const returnUrl = `${pathname}${location.search}${location.hash}`;
      localStorage.setItem('xerxesState', returnUrl);
      localStorage.setItem('dashboard_name', pathname);
    }
    this.router.navigate(['/splash']);
    this.dialogRef.close();
  }
}
